import axios from 'axios'
import { DealerProps } from 'features/dealer-locator/types'

import { get } from '../index'

export type GetDealersResponse = { dealers: DealerProps[] }

export type GetDealerByIdResponse = {
  id: string
  type: string
  attributes: {
    site_uri: string
    full_name: string
    address: string
  }
}

export const getDealers = (getDealersUrl: string) => get<GetDealersResponse>(getDealersUrl).then((r) => r.dealers)

export const getDealerById = (getDealerUrl: string) => get<GetDealerByIdResponse>(getDealerUrl).then((r) => r)
